import { Container, Row, Col, Button, Form } from 'react-bootstrap';
import '../../../App.css';
import '../../../css/bootstrap.scss';
import green_tick from "../../../images/green_tick.png";
import tick from "../../../images/tick.png";
import cross_icon from "../../../images/red_cross.png";
import { Link } from 'react-router-dom';
import Header from '../../Includes/Header';
import { useNavigate } from 'react-router-dom';
import countriesData from '../../../data/countries.json';
import { useState } from 'react';
import countriesStateData from '../../../data/states.json';
import { toHaveFormValues } from '@testing-library/jest-dom/matchers';
import BackButton from '../../Includes/BackButtonEntityAccount';

import { Field, reduxForm, InjectedFormProps } from 'redux-form';
import renderField from '../../renderField';
import { connect } from 'react-redux';
import { setEmail, setwizardPageNumber, setwizardPageName, setBusinessAddressDetails } from '../../EntityAccountReducer';
import { RootState } from '../../store';
import { useDispatch, useSelector } from 'react-redux';
import { ToastBox, notifyError } from 'MyComponents/Toaster';
import { useTranslation } from 'react-i18next';

interface Props { };

const SuccessRelatedPartiesForm: React.FC<Props & InjectedFormProps<{}, Props, FormData>> = (props: any) => {
    const { handleSubmit } = props;
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const page = useSelector((state: RootState) => state.entityAccount.wizardPageNumber);
    const entityAccountBusinessDetails = useSelector((state: RootState) => state.entityAccount.entityAccountBusinessDetails);

    const [validated, setValidated] = useState(false);

    const submitSuccessRelatedPartiesForm = async (formValues: FormData) => {
        dispatch(setwizardPageName("uploaddoc"));
        dispatch(setwizardPageNumber(6));
        localStorage.setItem('pageName', "uploaddoc");
        localStorage.setItem('pageNumber', '6');
    };

    return (
        <>
            <Container fluid className='min-vh-custom px-0 px-md-3'>
                <div className='pt-0 pb-3 mb-5 col-md-11 mx-auto px-2'>
                    <Row className="row justify-content-center">
                        <Col md={11}>
                            <p className=" fw-bold  d-inline">{t('kyc.entity_account_app')}</p>
                            <p className="text-warning d-inline ms-3 small">{t('common.in_progress')}</p>
                        </Col>
                    </Row>

                    <Row className='row justify-content-center'>
                        <Col className='col-md-12 text-center'>

                            <Row className='row mt-4' >
                                <Col md={12}>
                                    <svg width="50" height="50" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg" className="mb-2">
                                      <circle cx="30" cy="30" r="30" fill="#E6F9F2" />
                                      <circle cx="30" cy="30" r="16" fill="#00D084" />
                                      <path d="M24 30L28 34L37 25" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                    <h3 className='mt-2'>{t('kyc.completed_item')}</h3>
                                    <p className='text-secondary mt-2'>{t('kyc.completed_item_desc')}</p>
                                </Col>
                            </Row>

                            <Form noValidate={true} onSubmit={handleSubmit(submitSuccessRelatedPartiesForm)}>
                                <Row className='row mt-3  justify-content-center mb-3 '>
                                    <Col md={12}>
                                        <Button type="submit" className="btn btn-secondary rounded-5  mt-2 text-center border-0" style={{ background: "#0B1628" }}>{t('kyc.continue_document')}</Button>
                                    </Col>
                                </Row>
                            </Form>

                        </Col>
                    </Row>
                </div>
            </Container>
        </>
    );
}

const form = reduxForm<{}, Props, FormData>({
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    form: 'successRelatedParties',
    enableReinitialize: true,
})(SuccessRelatedPartiesForm);

export default connect(null)(form);
